import React from 'react'
import { styled } from '@mui/material/styles'
import DialogHeader from './DialogHeader'
import DialogContent from './DialogContent'
import DialogFooter from './DialogFooter'
import AlertDialogHeader from './AlertDialogHeader'
import { Dialog, Divider } from '@mui/material'

const PREFIX = 'CustomDialog'

const classes = {
  content: `${PREFIX}-content`,
}

const StyledDialog = styled(Dialog)({
  [`& .${classes.content}`]: {
    padding: 24,
  },
})

const getDialogHeader = props => {
  return props.variant !== 'alert' ? (
    <DialogHeader {...props} />
  ) : (
    <AlertDialogHeader {...props} />
  )
}

const CustomDialog = props => {
  const {
    open,
    maxWidth,
    fullWidth,
    actionContent,
    onClose,
    contentStyles,
    hideDivider,
    onEnter,
    children,
  } = props

  return (
    <StyledDialog
      fullWidth={fullWidth}
      open={open}
      maxWidth={maxWidth}
      onClose={onClose}
      aria-labelledby="dialog-title"
      TransitionProps={{
        onEnter,
      }}
    >
      {getDialogHeader(props)}

      {children ? (
        <DialogContent
          classes={{ root: classes.content }}
          style={{ ...contentStyles }}
        >
          {children}
        </DialogContent>
      ) : null}

      {hideDivider || props.variant === 'alert' ? null : <Divider />}

      {actionContent ? <DialogFooter {...props} /> : null}
    </StyledDialog>
  )
}

export default CustomDialog
CustomDialog.displayName = 'Custom Dialog'
